// Persist the "pin group headers" view preference across reloads. It's a single
// global toggle (not per-site), stored as '1' / '0'. Guarded like utils/lastSite
// so a blocked or unavailable localStorage (private mode, SSR) silently falls
// back to the default-off instead of throwing.
const KEY = 'dorca_scheduler_sticky_groups';

export function readStickyGroupsPref(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function writeStickyGroupsPref(value: boolean): void {
  try { localStorage.setItem(KEY, value ? '1' : '0'); } catch { /* ignore */ }
}
